import commonHelper from '@/app/utility/common.helper.utility';
export default {
  name: 'unReconcileData',
  props: ['rowData'],
  watch: {
    currentPage: function() {
      this.getIsdReconcileData();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getIsdUnReconcileDatax();
    },
    currentPage1: function() {
      this.getReconcileDataPeriodWise();
    },
    perPage1: function() {
      this.currentPage1 = 1;
      this.getReconcileDataPeriodWise();
    }
  },
  data() {
    return {
      loader: false,
      perPage: commonHelper.perPageRecord,
      currentPage: 1,
      totalRows: null,
      pageOptions: commonHelper.getPageOption(),
      perPage1: commonHelper.perPageRecord,
      currentPage1: 1,
      totalRows1: null,
      pageOptions1: commonHelper.getPageOption(),
      isdNonReconcileData: [],
      isdNonReconcileField: [
        {
          key: 'PeriodName',
          label: 'Period Name',
          class: 'text-center'
        },
        {
          key: 'FpGst',
          label: 'FP GSTN',
          class: 'text-center'
        },
        {
          key: 'NonrecCgst',
          label: 'CGST',
          class: 'text-center'
        },

        {
          key: 'NonrecSgst',
          label: 'SGST',
          class: 'text-center'
        },
        {
          key: 'NonrecIgst',
          label: 'IGST',
          class: 'text-center'
        },
        {
          key: 'NonrecTotalTax',
          label: 'Total Tax',
          class: 'text-center'
        },
        {
          key: 'RecCgst',
          label: 'CGST',
          class: 'text-center'
        },
        {
          key: 'RecSgst',
          label: 'SGST',
          class: 'text-center'
        },
        {
          key: 'RecIgst',
          label: 'IGST',
          class: 'text-center'
        },
        {
          key: 'RecTotalTax',
          label: 'Total Tax',
          class: 'text-center'
        }
      ],
      showIsdPeriodWiseDetails: false,
      period: null,
      isdNonReconcilePeriodData: [],
      isdNonReconcilePeriodField: [
        {
          key: 'PeriodName',
          label: 'Period',
          class: 'text-center'
        },
        {
          key: 'InvoiceNum',
          label: 'Invoice Number',
          class: 'text-center'
        },
        {
          key: 'InvoiceDate',
          label: 'Invoice Date',
          class: 'text-center'
        },
        {
          key: 'InvoiceAmount',
          label: 'Invoice Amount',
          class: 'text-center'
        },
        {
          key: 'GlDate',
          label: 'GL Date',
          class: 'text-center'
        },
        {
          key: 'NonrecCgst',
          label: 'CGST',
          class: 'text-center'
        },
        {
          key: 'NonrecSgst',
          label: 'SGST',
          class: 'text-center'
        },
        {
          key: 'NonrecIgst',
          label: 'IGST',
          class: 'text-center'
        },
        {
          key: 'RecCgst',
          label: 'CGST',
          class: 'text-center'
        },
        {
          key: 'RecSgst',
          label: 'SGST',
          class: 'text-center'
        },

        {
          key: 'RecIgst',
          label: 'IGST',
          class: 'text-center'
        },
        {
          key: 'SacCode',
          label: 'SAC Code',
          class: 'text-center'
        },
        {
          key: 'TaxInvoiceNum',
          label: 'Tax Invoice Number',
          class: 'text-center'
        },
        {
          key: 'VendorName',
          label: 'Vendor Name',
          class: 'text-center'
        },
        {
          key: 'TaxRatePercentage',
          label: 'Tax Rate Percentage',
          class: 'text-center'
        },
        {
          key: 'TaxableAmount',
          label: 'Taxable Amount',
          class: 'text-center'
        }
      ],
      downloadPayload: null,
      downloadPayload1: null
    };
  },
  mounted() {
    this.getIsdReconcileData();
  },
  methods: {
    getIsdReconcileData() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        le_id: this.rowData.LeId,
        fp_gst: this.rowData.IsdGstn,
        dist_period: this.rowData.DistPeriodName
      };
      this.downloadPayload = payload;
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getIsdReconcileData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.isdNonReconcileData = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openDataByPeriod(item) {
      this.period = item.PeriodName;
      this.showIsdPeriodWiseDetails = true;
      this.getReconcileDataPeriodWise();
    },
    showHideIsdPeriodWiseDetails(flag) {
      this.showIsdPeriodWiseDetails = flag;
    },
    getReconcileDataPeriodWise() {
      const payload = {
        _page: this.currentPage1 - 1,
        _limit: this.perPage1,
        le_id: this.rowData.LeId,
        fp_gst: this.rowData.IsdGstn,
        dist_period: this.rowData.DistPeriodName,
        period_name: this.period
      };
      this.downloadPayload1 = payload;
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/getReconcileDataPeriodWise', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.isdNonReconcilePeriodData = response.data.data.page;
            this.totalRows1 = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    downloadUnReconcileDataByPeriod() {
      this.loader = true;
      const downloadpayload = { ...this.downloadPayload1 };
      downloadpayload._limit = this.totalRows1;
      this.downloadExcel.downloadData(
        downloadpayload,
        'isdRevenue/getReconcileDataPeriodWise',
        'Reconcile Data Period Wise',
        () => (this.loader = false)
      );
    },
    downloadUnReconcileData() {
      this.loader = true;
      const downloadpayload = { ...this.downloadPayload };
      downloadpayload._limit = this.totalRows;
      this.downloadExcel.downloadData(
        downloadpayload,
        'isdRevenue/getIsdReconcileData',
        'Reconcile Data',
        () => (this.loader = false)
      );
    }
  }
};
